import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
interface IntroPhaseProps {
  onComplete: () => void;
}
export const IntroPhase = ({
  onComplete
}: IntroPhaseProps) => {
  useEffect(() => {
    // Auto-advance after animation completes
    const timer = setTimeout(() => {
      onComplete();
    }, 4500);
    return () => clearTimeout(timer);
  }, [onComplete]);
  return <motion.div className="fixed inset-0 z-50 flex items-center justify-center bg-black overflow-hidden" initial={{
    opacity: 1
  }} exit={{
    opacity: 0,
    transition: {
      duration: 1.5,
      ease: 'easeInOut'
    }
  }} data-id="element-12">
      {/* Mystical Smoke/Fog Effect (simulated with blurred animated divs) */}
      <motion.div className="absolute inset-0 opacity-40 blur-3xl" animate={{
      background: ['radial-gradient(circle at 50% 50%, #1a3a3a 0%, transparent 50%)', 'radial-gradient(circle at 60% 40%, #3a0f10 0%, transparent 60%)', 'radial-gradient(circle at 40% 60%, #1a3a3a 0%, transparent 50%)']
    }} transition={{
      duration: 4,
      ease: 'easeInOut'
    }} data-id="element-13" />

      <motion.div className="relative z-10 flex flex-col items-center" initial={{
      scale: 0.8,
      opacity: 0,
      filter: 'blur(10px)'
    }} animate={{
      scale: 1,
      opacity: 1,
      filter: 'blur(0px)'
    }} transition={{
      duration: 2,
      delay: 0.5
    }} data-id="element-14">
        <div className="mb-6 text-center leading-none" style={{
        color: '#C9A84C',
        fontSize: '64px',
        textShadow: '0 0 20px rgba(201, 168, 76, 0.5)'
      }} aria-hidden="true" data-id="element-15">
          ✦
        </div>
        <h1 className="font-cinzel text-3xl md:text-5xl text-gold text-shadow-gold tracking-[0.2em] text-center" data-id="element-16">
          EL TAROT
          <br data-id="element-17" />
          TURCO
        </h1>
        <motion.p className="mt-6 font-cormorant italic text-center" style={{
        color: '#F5F0E8',
        fontSize: '17px',
        letterSpacing: '0.05em'
      }} initial={{
        opacity: 0,
        y: 6
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.2,
        delay: 2.5
      }} data-id="element-18">
          Te estábamos esperando... y llegaste a tiempo.
        </motion.p>
      </motion.div>
    </motion.div>;
};